import React from 'react';
import { Box, Tooltip, useTheme } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * Shared Control Center info icon + modern tooltip surface.
 */
export default function ControlCenterInfoTooltip({
  title,
  iconSize = 14,
  sx,
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  if (!title) return null;

  return (
    <Tooltip
      title={title}
      arrow
      placement="top"
      enterDelay={180}
      enterNextDelay={120}
      enterTouchDelay={0}
      leaveTouchDelay={2800}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: 300,
            px: 1.5,
            py: 1.25,
            borderRadius: 2,
            fontSize: 12.5,
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: '0.01em',
            bgcolor: isDark ? '#1e293b' : '#0f172a',
            color: '#f8fafc',
            boxShadow: isDark
              ? '0 10px 28px rgba(0, 0, 0, 0.45)'
              : '0 10px 28px rgba(15, 23, 42, 0.22)',
            border: isDark ? '1px solid #334155' : '1px solid transparent',
          },
        },
        arrow: {
          sx: {
            color: isDark ? '#1e293b' : '#0f172a',
          },
        },
      }}
    >
      <Box
        component="span"
        role="img"
        aria-label="More info"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        onMouseDown={(e) => e.stopPropagation()}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          ml: 0.4,
          color: 'text.disabled',
          cursor: 'help',
          verticalAlign: 'middle',
          borderRadius: '50%',
          transition: 'color 0.15s ease, background-color 0.15s ease',
          '&:hover': {
            color: 'text.secondary',
            bgcolor: isDark ? 'rgba(148, 163, 184, 0.12)' : 'rgba(15, 23, 42, 0.06)',
          },
          ...sx,
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: iconSize }} />
      </Box>
    </Tooltip>
  );
}
